module.exports = __webpack_public_path__ + "static/media/worker-img1.e3e86d4d.webp";